import englishMessages from "ra-language-english"
import localeEn from "./english"

export default {
  ...englishMessages,
  resources: {
    ...localeEn,
  },
}
